const baseStyle = () => ({
  padding: 4,
  alignItems: 'flex-start',
  flex: 1,
  justifyContent: 'space-between',
  space: 2,

  _description: {
    fontSize: 'md',
    lineHeight: 'md',
  },
  _icon: {
    size: 6,
    minWidth: 6,
  },
  _title: {
    fontSize: 'md',
    lineHeight: 'md',
    fontWeight: '600',
  },
});

const colorSchemeMap: { [key: string]: string } = {
  error: 'error',
  warning: 'warning',
  info: 'info',
};

const lightVariant = ({ colorScheme }: Record<string, any>) => {
  const color = colorSchemeMap[colorScheme] ?? 'info';
  return {
    bg: `${color}.50`,
    _button: {
      colorScheme: color,
    },
    _buttonHover: {
      bg: `${color}.100`,
    },
    _title: {
      color: 'gray.900',
    },
    _description: {
      color: 'gray.900',
    },
    _dismiss: {
      colorScheme: color,
      _icon: {
        color: 'gray.900',
      },
    },
    _icon: {
      color: 'gray.900',
    },
  };
};

const darkSecondaryMap: { [key: string]: string } = {
  info: 'white',
  error: 'white',
  warning: 'gray.900',
};

const darkBackgroundMap: { [key: string]: string } = {
  info: '500',
  error: '500',
  warning: '300',
};

const darkVariant = ({ colorScheme }: Record<string, any>) => {
  const color = colorSchemeMap[colorScheme] ?? 'info';
  const secondaryColor = darkSecondaryMap[color];
  return {
    bg: `${color}.${darkBackgroundMap[color]}`,
    _button: {
      colorScheme: color,
      borderColor: secondaryColor,
      _text: {
        color: secondaryColor,
      },
    },
    _buttonHover: {
      bg: `${color}.400`,
    },
    _buttonPressed: {
      bg: `${color}.600`,
    },
    _title: {
      color: secondaryColor,
    },
    _description: {
      color: secondaryColor,
    },
    _dismiss: {
      colorScheme: color,
      _icon: {
        color: secondaryColor,
      },
      _hover: {
        bg: `${colorScheme}.400`,
      },
      _pressed: {
        bg: `${colorScheme}.600`,
      },
    },
    _icon: {
      color: secondaryColor,
    },
  };
};

const variants = {
  light: lightVariant,
  dark: darkVariant,
};

const defaultProps = {
  variant: 'dark',
  colorScheme: 'info',
};

export default {
  baseStyle,
  defaultProps,
  variants,
};
